<template>
  <div class="app-scroll-container">
    <NuxtLayout>
      <NuxtPwaManifest />
      <!-- <v-app> -->
      <NuxtPage />
      <!-- </v-app> -->
    </NuxtLayout>
  </div>
</template>

<script setup lang="ts">
import { general } from '@/utils/resize'
import { verifyLoginApi } from '@/apis/store'

import { init as initGa, send } from '@tuyoo-web-infra/ga-track-lib/packages/core/dist'
import packageJson from '../package.json'
import armsRum from '@arms/rum-browser'

const runConfig = useRuntimeConfig()
const { cache } = useCache('local')
const userStore = useUserStore()
const verify = () => {
  verifyLoginApi({
    authCode: cache.get('TU_Auth') || '',
    clientId: cache.get('TU_CLIENTID') || '',
    userId: cache.get('TU_USER') ? JSON.parse(cache.get('TU_USER')).userId : '',
  }).then(res => {
    if (res.code === 0) {
      cache.set('TU_TOKEN', res.data.web_token)
    } else {
      cache.set('TU_USER', null)
      cache.set('TU_TOKEN', null)
      cache.set('TU_Auth', null)
    }
  }).catch((error) => {
    cache.set('TU_USER', null)
    cache.set('TU_TOKEN', null)
    cache.set('TU_Auth', null)
  })
}

const init = () => {
  TuyooSdk.sdkRoute.set("/open/v6/user/official/web/login")
  TuyooSdk.OnInit(general.channelType, {
    ...general, ...{
      "baseurl": runConfig.public.sdkUrl || '',
      "redirectURI": runConfig.public.sdkRedirectURI || '',
      "redirect_uri": runConfig.public.sdkRedirectURI || ''
    }
  }, function (status, ChannelType, error) {
    if (status === 0) {
      console.log("初始化成功了: ++++++++" + ChannelType);
    } else {
      console.log("初始化失败了了!", status, ChannelType);
      console.log(error);
    }
  });
}

// const errorLogout = (e: ErrorEvent) => {
//   const { message, lineno, target, error } = e
//   if (!target) {
//     return;
//   }
//   let stack = error ? error.stack : ''
//   send('h5_error_log', {
//     h5_error_msg: message,
//     h5_error_line: lineno,
//     h5_error: error?.toString() || '',
//     h5_error_stack: stack
//   })
// }

onMounted(() => {
  nextTick(() => {
    init()

    if (cache.get('TU_TOKEN')) {
      verify()
    }
  })

  initGa({
    project_id: '20561',
    type: 'track',
    client_id: 'H5_5.0_tuyoo.tuyoo.0-hall20561.yuenan.hwfish3d',
    properties: {
      proj_client_id: 'H5_5.0_tuyoo.tuyoo.0-hall20561.yuenan.hwfish3d',
      proj_game_id: '20561',
      proj_app_id: '20561',
      proj_language_id: 'vn',
      proj_cloud_id: '139',
      proj_page_name: '20561_official_website',
    },
  })
  const ENV = runConfig.public.sdkEnv || ''
  const nodeEnv = process.env.NODE_ENV || ''
  console.log(ENV, nodeEnv);
  //development模式关闭
  if (nodeEnv && nodeEnv !== 'development') {
    console.log(ENV, nodeEnv);
    armsRum.init({
      pid: "e77cea4j4i@ae41f16b5b3166a",
      endpoint: "https://e77cea4j4i-default-cn.rum.aliyuncs.com",
      env: ENV === 'production' ? 'prod' : 'pre', // 生产 prod 测试 pre
      version: packageJson.version, // package.json version
      spaMode: "hash",
    })
    // window.addEventListener('error', errorLogout)
    // window.addEventListener('unhandledrejection', errorLogout)
  }
  window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
})
const handleBeforeInstallPrompt = (e) => {
  e.preventDefault();
  userStore.setDeferredPrompt(e)
}

onBeforeUnmount(() => {
  window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
});
</script>

<style lang="scss">
@import url(./assets/styles/store.scss);
@import url(./assets/styles/element.scss);
@import url(./assets/styles/fade.scss);
@import url(./assets/styles/entry.scss);
@import url(./assets/styles/global.scss);

body {
  // margin: 0;
  // scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}

.app-scroll-container {
  // height: 100vh;
  overflow: auto;
  scroll-behavior: smooth;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
